import { Adornment } from '../controls';

export default function AdornmentField({ input, ...props }) {
  return <Adornment value={input.value} onChange={input.onChange} {...props} />;
}
